const ERRORS = {
	REQUIRED: "This field is required.",
	DUPLICATED: "The submitted information already exists in our database.",
	LENGTH: "Use at least 8 characters",
	NUMERIC: "Should contain at least 1 numeric",
	UPPERCASE: "Should contain at least 1 uppercase",
	LOWERCASE: "Should contain at least 1 lowercase",
	SYMBOL: "Should contain at least 1 special character",
	CONFIRM_PASSWORD: "Password confirmation doesn't match.",
	FILE_SIZE: "File Size is too large (maximum 5MB)",
	FILE_SIZE_30: "File Size is too large (maximum 30MB)",
	TOTAL_FILE_SIZE_60: "Total 	File Size is too large (maximum 60MB)",
	TOTAL_FILE_SIZE_50: "Total File Size is too large (maximum 50MB)",
	FILE_TYPE_JPG_PDF: "Only JPG or PDF files are allowed.",
	MININUM_ITEM: "Field must have at least 1 items",
	START_DATE: "Start Date must be before end date",
	START_DATE_EXPIRED: "Start Date must be today or future date",
	END_DATE: "End Date must be after start date",
	EMAIL: "Please provide a valid email",
	ANNOUNCEMENT_IMAGE_SIZE: "File dimension should at least be (400px x 400px)",
	PROFILE_IMAGE_SIZE: "File size not exceeding 5MB.",
	PROFILE_IMAGE_TYPE: "Only JPG, JPEG or PNG files are allowed.",
	AVATAR_FILE_TYPE: "Only JPG or PNG images are allowed.",
	AVATAR_FILE_SIZE: "File size must not exceed 5MB.",
	AVATAR_FILE_EMPTY: "Please choose a file.",
	DOCUMENTS_SIZE_10MB: "File size not exceeding 10MB.",
	DOCUMENTS_SIZE_15MB: "File size not exceeding 10MB.",
	INVALID_AGE: "This employee is currently ineligible for coverage",
	INVALID_ID: "Please provide a valid information",
	SPACE: "Password should not contain spaces",
	ALPHABET_ONLY: "This field must contain only alphabetic characters",
	NUMBERS_ONLY: "Must be a whole number",
	MOBILE_NO_MIN: "Mobile number must be at least 8 digits",
	MOBILE_NO_MAX: "Mobile number must not exceed 12 digits",
	INFO_CONFIRMED: "Please confirm the accuracy of the information.",
	ACKNOWLEDGE_POLICY: "Please confirm you understand the consequences of false information.",
	MININUM_EMPLOYEE: "Please select at least 1 employee",
	MINIMUM_DAY: "Please add at least 1 day",
	MINIMUM_NUMBER: "Must be at least 1",
	UNIQUE: "Value must be unique from other values",
	END_TIME_AFTER_START: "End Time must be after Start Time",
	OVERTIME_DATE_RANGE: "Overtime date must be within the last 1 month and before today",
	REJECT_REMARKS_REQUIRED: "Remarks are required when the reason is Others",
	ALLOWANCE_AMOUNT_REQUIRED: "Please enter a valid allowance amount",
	EXPIRY_DATE_INVALID: "Expiry date must be today or a future date",
};

export default ERRORS;
